import React from 'react';
import { MessageSquare, BarChart2, FileText, Lightbulb, Users, Zap, Target, LogIn } from 'lucide-react';
import '../styles/TopNavBar.css';

interface TopNavBarProps {
  currentStep?: number;
  isAuthenticated: boolean;
  userEmail?: string | null;
  onLogin?: () => void;
  onLogout?: () => void;
  showSteps?: boolean;
  completedSteps?: number[];
  onNavigateToStep?: (step: number) => void;
}

const TopNavBar: React.FC<TopNavBarProps> = ({
  currentStep = 1,
  isAuthenticated,
  userEmail,
  onLogin,
  onLogout,
  showSteps = false,
  completedSteps = [],
  onNavigateToStep,
}) => {
  // Navigation items representing the pipeline steps
  const navItems = [
    { id: 1, icon: MessageSquare, label: 'Config',     step: 1 },
    { id: 2, icon: FileText,      label: 'Brief',      step: 2 },
    { id: 3, icon: Target,        label: 'Audiences',  step: 3 },
    { id: 4, icon: Lightbulb,     label: 'Summary',    step: 4 },
    { id: 5, icon: BarChart2,     label: 'Scenarios',  step: 5 },
    { id: 6, icon: Zap,           label: 'Strategy',   step: 6 },
    { id: 7, icon: Users,         label: 'Actions',    step: 7 },
  ];

  // Get user initials for avatar
  const getUserInitials = (email: string) => {
    const name = email.split('@')[0];
    const parts = name.split('.');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  return (
    <nav className="top-nav-bar">
      {/* Logo */}
      <div className="nav-logo">
        <img src="/Incubeta_Logo.png" alt="Incubeta" className="logo" />
      </div>

      {/* Navigation Items - Pipeline Steps */}
      {(isAuthenticated || showSteps) && (
        <div className="nav-items">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = isAuthenticated && currentStep === item.step;
            const isComplete = completedSteps.includes(item.step);
            const isAccessible = isAuthenticated && (item.step <= currentStep || isComplete);

            return (
              <button
                key={item.id}
                className={`nav-item ${isActive ? 'active' : ''} ${isComplete ? 'complete' : ''} ${!isAccessible ? 'disabled' : ''}`}
                disabled={true}
                title={item.label}
              >
                <Icon size={16} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      )}

      {/* Auth Section */}
      {isAuthenticated && (
        <div className="nav-auth">
          {userEmail ? (
            <div className="user-profile" onClick={onLogout} title={userEmail}>
              <div className="user-avatar">
                {getUserInitials(userEmail)}
              </div>
            </div>
          ) : null}
        </div>
      )}
    </nav>
  );
};

export default TopNavBar;